import OddsAdvertisement, {
  ODDS_ADVERTISEMENT_PROVIDER,
} from "../components/OddsAdvertisement";
import { randomNumber } from "./number";

export const leagueOddsSlugs = [
  { leagueId: 3, slug: "[sweden]/[[allsvenskan]]" },
  { leagueId: 4, slug: "[sweden]/[[superettan]]" },
  {
    leagueId: 8,
    slug: "[england]/[[premier_league]]",
  },
  {
    leagueId: 9,
    slug: "[italy]/[[serie_a]]",
  },
  {
    leagueId: 10,
    slug: "[spain]/[[la_liga]]",
  },
  {
    leagueId: 30,
    slug: "[germany]/[[bundesliga]]",
  },
  {
    leagueId: 33,
    slug: "[france]/[[ligue_1]]",
  },
];

export const categoryOddsSlugs = [
  { categoryId: 11, slug: "[sweden]/[[allsvenskan]]" },
  { categoryId: 13, slug: "[sweden]/[[superettan]]" },
  {
    categoryId: 12,
    slug: "[euro_2024]/[[all]]",
  },
  {
    categoryId: 14,
    slug: "[euro_2024]/[[all]]",
  },
  {
    categoryId: 16,
    slug: "[euro_2024]/[[all]]",
  },
  {
    categoryId: 18,
    slug: "[euro_2024]/[[all]]",
  },
];

export const getPlayerText = (positionName: string, name: string) => {
  switch (positionName) {
    case "Målvakt":
      return `Håller ${name} nollan i nästa match? Spela här.`;

    case "Försvarare":
      return `Får ${name} gult kort i nästa match? Spela här.`;

    case "Mittfältare":
      return `Gör ${name} assist i nästa match? Spela här.`;

    case "Anfallare":
      return `Vinner ${name} skytteligan? Spela här.`;

    default:
      return null;
  }
};

export const getNewsText = (categoryId: number) => {
  // switch (categoryId) {
  //   case 11:
  //     return "Vem vinner Allsvenskan 2024? Spela här.";

  //   case 12:
  //     return "Vem vinner Premier League 2024? Spela här.";

  //   case 13:
  //     return "Vem vinner Superettan 2024? Spela här.";

  //   case 14:
  //     return "Vem vinner Serie A 2024? Spela här.";

  //   case 16:
  //     return "Vem vinner La Liga 2024? Spela här.";

  //   default:
  //     return "Vem vinner Allsvenskan 2024? Spela här.";
  // }

  return (
    <div className="mx-2">
      <div className="font-bold">
        Få 100% bonus upp till 600 kronor! Annons.
      </div>
      <div className="text-xs">
        Oms.krav. 8x. Giltig 90d. Klicka här för villkor.
      </div>
    </div>
  );
};

export const getCasinoAdvertisement = (clubIds: number[], type: string) => {
  const includesAik = clubIds.some((id) =>
    [6314, 5744, 5113, 4966, 3246, 867, 4].includes(id)
  );

  const includesHammarby = clubIds.some((id) =>
    [5887, 5120, 5025, 5024, 4341, 1086, 875, 54, 9].includes(id)
  );

  const includesBoth = includesAik && includesHammarby;

  const club = includesBoth
    ? ["aik", "hammarby"][randomNumber(0, 1)]
    : includesAik
    ? "aik"
    : includesHammarby
    ? "hammarby"
    : undefined;

  if (club === "aik") {
    if (type === "transfers-desktop") {
      return (
        <OddsAdvertisement
          url=""
          provider={ODDS_ADVERTISEMENT_PROVIDER.COMEON}
          bottomText="18+ Stödlinjen.se"
        />
      );
    }

    if (type === "transfers-mobile") {
      return (
        <OddsAdvertisement
          url=""
          provider={ODDS_ADVERTISEMENT_PROVIDER.COMEON}
          showDisclaimer
          text="Spela här"
        />
      );
    }

    return (
      <OddsAdvertisement
        url=""
        provider={ODDS_ADVERTISEMENT_PROVIDER.COMEON}
        showDisclaimer
        text={
          <div className="mx-2">
            <div className="font-bold">AIK erbjudande</div>
            <div className="text-xs">
              Oms.krav. 8x. Giltig 90d. Klicka här för villkor.
            </div>
          </div>
        }
      />
    );
  }

  if (club === "hammarby") {
    if (type === "transfers-desktop") {
      return (
        <OddsAdvertisement
          url=""
          provider={ODDS_ADVERTISEMENT_PROVIDER.SNABBARE}
          bottomText="18+ Stödlinjen.se"
        />
      );
    }

    if (type === "transfers-mobile") {
      return (
        <OddsAdvertisement
          url=""
          provider={ODDS_ADVERTISEMENT_PROVIDER.SNABBARE}
          showDisclaimer
          text="Spela här"
        />
      );
    }

    return (
      <OddsAdvertisement
        url=""
        provider={ODDS_ADVERTISEMENT_PROVIDER.SNABBARE}
        showDisclaimer
        text={
          <div className="mx-2">
            <div className="font-bold">Hammarby erbjudande</div>
            <div className="text-xs">
              Oms.krav. 8x. Giltig 90d. Klicka här för villkor.
            </div>
          </div>
        }
      />
    );
  }

  if (type === "transfers-desktop") {
    return (
      <OddsAdvertisement
        url=""
        provider={ODDS_ADVERTISEMENT_PROVIDER.SNABBARE}
        bottomText="18+ Stödlinjen.se"
      />
    );
  }

  if (type === "transfers-mobile") {
    return (
      <OddsAdvertisement
        url=""
        provider={ODDS_ADVERTISEMENT_PROVIDER.SNABBARE}
        showDisclaimer
        text="Spela här"
      />
    );
  }

  return (
    <OddsAdvertisement
      url=""
      provider={ODDS_ADVERTISEMENT_PROVIDER.SNABBARE}
      showDisclaimer
      text={
        <div className="mx-2">
          <div className="font-bold">
            Få 100% bonus upp till 600 kronor! Annons.
          </div>
          <div className="text-xs">
            Oms.krav. 8x. Giltig 90d. Klicka här för villkor.
          </div>
        </div>
      }
    />
  );
};

export const getGamesTitleByCampaignId = (
  gameCount: number,
  campaignId: number
) => {
  let club = "";

  if (campaignId === 12) {
    club = "AIK";
  } else if (campaignId === 13) {
    club = "Hammarby IF";
  }

  if (!club) {
    return undefined;
  }

  return gameCount === 1
    ? `Kommande match - ${club}`
    : `Kommande ${gameCount} matcher - ${club}`;
};

export const getGamesTitleByCategoryId = (
  gameCount: number,
  categoryId: number
) => {
  let league = "";

  if (categoryId === 11) {
    league = "Allsvenskan";
  } else if (categoryId === 13) {
    league = "Superettan";
  } else if (categoryId === 12) {
    league = "Premier League";
  } else if (categoryId === 16) {
    league = "La Liga";
  } else if (categoryId === 14) {
    league = "Serie A";
  }

  if (!league) {
    return `Kommande matcher`;
  }

  return gameCount === 1
    ? `Kommande match - ${league}`
    : `Kommande ${gameCount} matcher - ${league}`;
};

export const getGamesLeagueByCategoryId = (categoryId: number) => {
  switch (categoryId) {
    case 11:
      return 3;
    case 13:
      return 4;
    case 12:
      return 8;
    case 16:
      return 10;
    case 14:
      return 9;
  }
};
